// services/socket.js
import { io } from 'socket.io-client';

const socket = io(process.env.REACT_APP_URL_API3);

export default socket;
